<template>
<div class="wrap">
  <div class="lyDim" style="z-index:9999" @click="onClickDim"></div>
  <section class="layerPop layerPopCustom">
    <div class="lyWrap">

      <h1 class="lyTit lyTitCustom">
        <slot name="title"></slot>
      </h1>
      
      <div class="lyCon lyConCustom">
        <slot name="content"></slot>
      </div>
      
      <div class="btnBox">
        <slot name="button"></slot>
      </div>

      <button v-if="isClosed" type="button" class="btnClose" @click="close">닫기</button>

    </div>
  </section>
</div>
</template>


<script>
export default {
  mounted() {
    if(this.$el['style'].display !== 'none'){
      this.$store.commit('openPopup', {
        name: 'popup',
        isConfirm: this.isConfirm,
      })
    }
  },

  destroyed() {
    this.$store.commit('closePopup', {
      name: 'popup',
      isConfirm: this.isConfirm,
    })
  },

  props: {
    isConfirm: null,
    isClosed: {type: Boolean, default: false}
  },

  methods:{
    onClickDim(){
      if(this.isConfirm !== true) {
        this.$emit('close');
      }
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="css" scoped>
.layerPopCustom{
  display: block; 
  z-index:9999;
  width:100%;
  max-width:600px;
  top:50%; left:50%;
  transform: translate(-50%, -50%);
}

.lyConCustom{
  /*noinspection CssUnresolvedCustomProperty*/
  max-height:calc((var(--vh, 1vh) * 100) - 225px);
}

.lyTitCustom{
  position: relative;
}
</style>